import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import heroAiImg from '../images/hero-ai-image.jpg';

const Hero = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-slate-900 relative overflow-hidden" id='hero'>
            {/* Subtle brand-colored glow accents */}
            <div className="absolute -top-24 -right-24 w-96 h-96 bg-primary opacity-20 rounded-full blur-3xl pointer-events-none" aria-hidden="true"></div>
            <div className="absolute -bottom-32 -left-24 w-96 h-96 bg-accent opacity-10 rounded-full blur-3xl pointer-events-none" aria-hidden="true"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                <div className="flex flex-col lg:flex-row items-center py-16 lg:py-24 gap-10">
                    <div className="lg:w-1/2 text-center lg:text-left" data-aos="fade-right">
                        <p className="text-accent font-bold tracking-wide uppercase text-sm mb-4">
                            {t('hero.tagline')}
                        </p>
                        <h1 className="mb-6 md:text-5xl text-3xl font-bold text-white leading-tight">
                            {t('hero.title')}
                        </h1>
                        <p className="text-lg lg:text-xl mb-8 text-gray-300 text-justify">
                            {t('hero.subtitle')}
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                            <Link
                                to="/contact"
                                className="text-white bg-primary hover:bg-primary-hover inline-flex items-center justify-center px-8 py-3 text-lg font-semibold shadow-xl rounded-xl transition-colors"
                            >
                                {t('hero.cta_primary')}
                                <svg className="w-4 h-4 ml-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                            </Link>
                            <Link
                                to="/solutions"
                                className="text-white border-2 border-gray-500 hover:border-accent hover:text-accent inline-flex items-center justify-center px-8 py-3 text-lg font-semibold rounded-xl transition-colors"
                            >
                                {t('hero.cta_secondary')}
                            </Link>
                        </div>
                    </div>
                    <div className="lg:w-1/2 flex justify-center" data-aos="fade-up" data-aos-delay="300">
                        <img alt={t('hero.title')} className="w-full max-w-xl h-auto" src={heroAiImg} width="1152" height="768" fetchPriority="high" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Hero;
